// No changes needed for Vite

import React from 'react'

export const PageTitle = ({
  children,
  ...props
}: { children: React.ReactNode } & React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h1 className="c-text-xl c-font-nexa c-font-semibold c-py-2 c-m-0" {...props}>
      {children}
    </h1>
  )
}

export default PageTitle
